<template>
  <div class="wd-100p rounded bd bd-2 bd-light bg-white pd-2-f">
    <div class="pd-10">
      <div class="d-flex">
        <div class="mg-r-10">
          <i
            data-v-4d521fc4
            data-name="credit-card"
            data-tags="purchase,payment,cc"
            data-type="credit-card"
            class="wd-40-f ht-40-f feather feather--credit-card"
          >
            <svg
              data-v-4d521fc4
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-credit-card feather__content"
            >
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
              <line x1="1" y1="10" x2="23" y2="10" />
            </svg>
          </i>
        </div>
        <div v-if="invoice.thirdOrganizationTask != undefined">
          <h6>{{ invoice.thirdOrganizationTask.task }}</h6>
          <span>{{ invoice.thirdOrganizationTask.task }}</span>
          <!-- <span>{{ invoice.thirdOrganizationTask.objectTypeId }}</span> -->
        </div>
        <div v-else>
          <h6>{{ invoice.task }}</h6>
          <!-- <span>{{invoice.objectTypeId}}</span> -->
        </div>
      </div>
    </div>
    <div class="bg-light pd-10">
      <div class="d-flex align-items-center bd-b pd-b-10 mg-b-10">
        <div>Огноо</div>
        <div class="mg-l-auto">
          {{ invoice.createdDate | moment("YYYY.MM.DD") }}
        </div>
      </div>
      <div class="d-flex align-items-center bd-b pd-b-10 mg-b-10">
        <div>Төлөх дүн</div>
        <div class="mg-l-auto">
          <h4 class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0">
            {{ invoice.budget | formatMoney(0, ".", ",") }} ₮
          </h4>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div>Төлбөр</div>
        <div class="mg-l-auto">
          <button
            v-if="!invoice.isTender"
            class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"
          >
            Төлөх
          </button>
          <template v-else>
            <template v-if="hasEbarimt">
              <button
                v-if="invoice.isTender"
                class="btn btn-sm pd-x-15 btn-success btn-uppercase mg-l-5"
              >
                И-Баримт
              </button>
            </template>
            <span v-else class="badge badge-success">Төлөгдсөн</span>
          </template>
          <!-- <h4
            class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0"
          >{{invoice.budget | formatMoney(0,'.',',')}} ₮</h4>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invoice: {
      type: Object,
      default: () => null
    },
    hasEbarimt: {
      type: Boolean,
      default: () => false
    }
  }
};
</script>
